/* eslint-disable import/first */

import config from 'config';

if (config.sentry.dsn) {
  window.Raven.config(config.sentry.dsn).install();
}

if (config.mixpanel.token) {
  window.mixpanel.init(config.mixpanel.token);
}

import React from 'react';
import {render} from 'react-dom';
import configureStore from 'store';
import {Router, Route, IndexRoute, browserHistory} from 'react-router';
import {syncHistoryWithStore, routerReducer} from 'react-router-redux';

import {login} from 'flows/session/reducer';
import {goAfterLogin} from 'utils/AuthService';
import {ApolloProvider} from 'react-apollo';
import apollo from 'utils/apollo';

import App from './containers/App';
import LeadInviteContainer from './flows/lead/invite';
import LeadDealContainer from './flows/lead/deal';
import InterestInviteContainer from './flows/interest/invite';
import InterestDealContainer from './flows/interest/deal';
import InterestInvestorContainer from './flows/interest/investor';
import InterestAccreditationContainer from './flows/interest/accreditation';
import InterestInvestmentContainer from './flows/interest/investment';
import InterestConfirmedContainer from './flows/interest/confirmed';
import InvestInviteContainer from './flows/invest/invite';
import InvestAgreementContainer from './flows/invest/agreement';
import InvestConfirmedContainer from './flows/invest/confirmed';
import DealLeadContainer from './flows/deal/lead';
import HomeContainer from './flows/home';
import RetrieveW9 from './flows/docs/w9';
import RetrieveDealUnsigned from './flows/docs/unsigned';
import RetrieveDealSigned from './flows/docs/signed';
import AccountContainer from './flows/account';

import Login from './containers/Login';
import LoggedIn from './containers/LoggedIn';
import moment from 'moment';

import './global.css';

// Create the store
const store = configureStore('routing', routerReducer, apollo);

// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(browserHistory, store);

// validate authentication for private routes
const requireAuth = (nextState, replace) => {
  // Already logged in?
  if (!store.getState().session.user.idToken) {
    // Check if we have a valid auth0 token cached
    const expiresAt = moment(JSON.parse(localStorage.getItem('expiresAt')));
    const now = moment();
    const valid = now.isBefore(expiresAt);

    if (valid) {
      // Log user in with cached token
      const authResult = JSON.parse(localStorage.getItem('authResult'));
      store.dispatch(login(authResult));
    } else {
      // Force login
      goAfterLogin(nextState.location.pathname);
      replace({pathname: '/login'});
    }
  }
};

/* eslint-disable max-len */
document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('mount');
  render(
    <ApolloProvider store={store} client={apollo}>
      <Router history={history}>
        <Route path="/" component={App}>
          <IndexRoute component={HomeContainer} onEnter={requireAuth} />
          <Route path="login" component={Login} />
          <Route path="loggedin" component={LoggedIn} />
          <Route path="lead/invite/:inviteId" component={LeadInviteContainer} />
          <Route path="lead/deals/:dealId/invites/:inviteId" component={LeadDealContainer} onEnter={requireAuth} />
          <Route path="interest/invite/:inviteId" component={InterestInviteContainer} />
          <Route path="interest/deals/:dealId/invites/:inviteId/after/:after/confirm/:confirm" component={InterestDealContainer} onEnter={requireAuth} />
          <Route path="interest/investor" component={InterestInvestorContainer} />
          <Route path="interest/accreditation" component={InterestAccreditationContainer} />
          <Route path="interest/investment" component={InterestInvestmentContainer} />
          <Route path="interest/confirm" component={InterestConfirmedContainer} />
          <Route path="invest/invite/:inviteId" component={InvestInviteContainer} />
          <Route path="invest/allocations/:allocationId/agreement/after/:after/confirm/:confirm" component={InvestAgreementContainer} onEnter={requireAuth} />
          <Route path="invest/confirm" component={InvestConfirmedContainer} />
          <Route path="deals/:dealId" component={DealLeadContainer} onEnter={requireAuth} />
          <Route path="docs/w9/:allocationId" component={RetrieveW9} onEnter={requireAuth} />
          <Route path="docs/allocation/signed/:allocationId" component={RetrieveDealSigned} onEnter={requireAuth} />
          <Route path="docs/deal/unsigned/:dealId" component={RetrieveDealUnsigned} onEnter={requireAuth} />
          <Route path="profile" component={AccountContainer} onEnter={requireAuth} />
        </Route>
      </Router>
    </ApolloProvider>, root);
});



// WEBPACK FOOTER //
// ./web/index.web.js